import axios from "axios";

export default function OfferitemPricelistitemShowService(offerId, itemId, listitemId) {
  return axios({
    method: 'get',
    url: process.env.REACT_APP_API_HOST + "/offer/" + offerId + "/item/" + itemId + "/priceListItem/" + listitemId,
    params: {},
    headers: {'Authorization': 'Bearer ' + localStorage.getItem("userToken"), 'App-Network': localStorage.getItem("networkId")}
  });
}
